<div class="ces-survey">
  <h3>Help us improve</h3>
  <p>How easy was it to submit your application?</p>
  <div class="faces-container">
    <div
      class="face-option"
      [class.selected]="selectedRating === i + 1"
      *ngFor="let label of labels; let i = index"
      (click)="select(i + 1)">
      <i class="face-icon" [class]="(i + 1) | getFaceIcon"></i>
      <span class="face-label">{{ label }}</span>
    </div>
  </div>
</div>
